export default __webpack_public_path__ + "images/9469c0436bab2702024a7d78a3288527-Sample-Icons.jpg";